var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating",style:({
    'font-size': `${_vm.size}px`,
})},[(!_vm.hasEmptyStars)?_c('span',{style:({ color: _vm.color, 'gap': `${_vm.gap}px` })},_vm._l((_vm.score),function(i){return _c('i',{key:'star-' + i,class:{
            'fas fa-star-sharp': true,
        }})}),0):_c('span',{style:({ color: _vm.color, 'gap': `${_vm.gap}px` })},_vm._l((5),function(i){return _c('i',{key:'star-' + i,class:{
            'fas fa-star-sharp': i <= _vm.score,
            'far fa-star-sharp': i > _vm.score,
        }})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }